import { styled } from 'styled-components';
import { formatNumberWithDot } from '@utils/functions/formatNumberWithDot';
import { TableColumnsType } from 'antd';
import { IReportAbcTable } from '@entities/reports';

interface ReportColumnProps {
    columns: string[];
}
export const createReportAbcColumns = ({
    columns,
}: ReportColumnProps): TableColumnsType<IReportAbcTable> => {
    return [
        ...columns?.map((column, index) => ({
            key: `column-${index}`,
            title: column,
            width: '25%',
            dataIndex: column,
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'] as any,
            align: (index !== 0 ? 'right' : 'left') as
                | 'right'
                | 'left'
                | 'center',
            render: (value: number | string) => (
                <StyledSum $isFirst={index === 0}>
                    {index === 2
                        ? formatNumberWithDot(value)
                        : `${value} ${index === 1 ? '%' : ''}`}
                </StyledSum>
            ),
        })),
    ];
};

const StyledSum = styled.div<{ $isFirst?: boolean }>`
    text-align: ${({ $isFirst }) => ($isFirst ? 'left' : 'right')};
    padding-right: 0.5em;
`;
